import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-agenda-add-item-form',
  templateUrl: './agenda-add-item-form.component.html',
  styleUrls: ['./agenda-add-item-form.component.scss']
})
export class AgendaAddItemFormComponent implements OnInit {

  constructor() { }
  
  ngOnInit() {}
}
